export default __webpack_public_path__ + "static/pic3-0db03c6ba52e2d0bd8d846495266f362.png";